import loadable from "@loadable/component";
import print from "print-js";
import { useParams, useSearchParams } from "react-router-dom";
import APIS from "../constant/EndPoint";
import useGetHook from "../customHooks/useGetHook";
import usePatchHook from "../customHooks/usePatchHook";
import usePDFPrintHook from "../customHooks/usePDFPrintHook";
import CreateIcon from "../Icons/CreateIcon";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import Spinner from "../Components/Reusable/Spinner";
import usePostHook from "../customHooks/usePostHook";
import { toast } from "react-toastify";
const EditPickupRequestComponent = loadable(
  () => import("../Components/PickupRequest/EditPickupRequest")
);
const EditPickupRequest = () => {
  const [searchParams, setSearchParms] = useSearchParams();
  const { id } = useParams();
  const { data, refetch, isLoading } = useGetHook({
    queryKey: [`pickup-request-${id}`],
    url: `${APIS.PICKUPREQUEST}${id}/`,
    params: {},
  });
  return (
    <div>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Pickup Request Details
        </span>
      </div>
      {isLoading ? (
        <Spinner />
      ) : (
        <EditPickupRequestComponent
          data={data}
        
        />
      )}
    </div>
  );
};

export default EditPickupRequest;
